<template>
  <div class="form-question-title">
    <h4 :class="`form-question-title__header d-inline-block mr-2 ${ margin ? 'mb-3' : '' }`">
      <slot />
      <v-tooltip class="form-question-title__tooltip d-none d-sm-inline" v-if="$slots.tooltip" right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="form-question-title__tooltip-icon info-help" v-bind="attrs" v-on="on">
            mdi-information
          </v-icon>
        </template>
        <span class="form-question-title__tooltip-text tooltip-txt">
          <slot name="tooltip" />
        </span>
      </v-tooltip>
    </h4>
    <p v-if="$slots.indications" class="form-question-title__indications">
      <slot name="indications" />
    </p>
  </div>
</template>

<script>
export default {
    name: "FormQuestion",
    props: {
        margin: {
            type: Boolean,
            default: false
        }
    }
};
</script>
